const { PermCameraMicRounded } = require("@material-ui/icons");
module.exports = {
  //BASE_URL: "http://localhost:5049/",
  //BASE_URL: "http://corobce.biztran.in/",
  //BASE_URL: "http://qrcode.biztran.in/",
  BASE_URL: "https://qr.corob.live/",
  form_list: [
    // {
    //   name: "Machine Master Details",
    //   path: "/",
    //   icon: "Extension",
    //   isMenuItem: 1,
    //   Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
    //   subMenu: [
    //     {
    //       name: "Machine Master Details",
    //       path: "/Cecertificate",
    //       icon: "Home",
    //       isMenuItem: 1,
    //       Authorization: ["Admin", "BA", "BA Head", "ISR", "IS Head", "Manager"],
    //     },
    //   ],
    // },
    {
      name: "Masters",
      path: "/",
      icon: "Extension",
      isMenuItem: 1,
      Authorization: ["Admin", "Engineer",],
      subMenu: [
        {
          name: "Machine Master Details",
          path: "/Cecertificate",
          icon: "Home",
          isMenuItem: 1,
          Authorization: ["Admin", "Engineer"],
        },
        {
          name: "Model Master",
          path: "/ModelMaster",
          icon: "EventNoteSmall",//CRM Sales Dashboard Icon
          isMenuItem: 1,
          Authorization: ["Admin", "Engineer"],
        },
        {
          name: "User Master",
          path: "/UserMaster",
          icon: "AccountBoxSmall",//CRM Sales Dashboard Icon
          isMenuItem: 1,
          Authorization: ["Admin",],
        },


      ],
    },


  ],
};
